import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EdlIpPillDTO } from 'src/app/model/item-packet/edl-ip-pill-dto.model';
import { InComplianceStatus } from '../enums/in-compliance-status.enum';
import { EdlItemPacketCplItemSummaryDTO } from 'src/app/model/item-packet/edl-item-packet-cpl-item-summary-dto.model';

@Component({
    selector: 'item-packet-pill',
    templateUrl: './item-packet-pill.component.html',
    styleUrls: ['./item-packet-pill.component.scss'],
})
export class ItemPacketPillComponent {
    private _items: EdlItemPacketCplItemSummaryDTO[] = [];
    private _missingItems: EdlItemPacketCplItemSummaryDTO[] = [];

    @Input() pill: EdlIpPillDTO;
    @Input() status?: InComplianceStatus;
    @Input() isRemovable: boolean = false;
    @Input() showTitle: boolean = false;
    @Input() showStatusStamp: boolean = false;
    
    @Input() 
    get items() { 
        return this._items;
    }

    set items(value: EdlItemPacketCplItemSummaryDTO[]) {
        this._items = value;
        this._missingItems = value.filter(item => item.Status === InComplianceStatus.MISSING && item.IsPublished);
    };

    @Output() onRemove = new EventEmitter<EdlIpPillDTO>();

    get missingItems() {
        return this._missingItems;
    }

    InComplianceStatus = InComplianceStatus;

    public onRemoveClicked = () => {
        this.onRemove.emit(this.pill);
    }
}
